/**
 * Cake in a Can — Scroll reveal animations
 */

function revealVisibleElements() {
  document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
      el.classList.add('is-visible');
    }
  });
}

function initScrollReveal() {
  const elements = document.querySelectorAll('[data-reveal]');
  const animationsEnabled = getComputedStyle(document.documentElement)
    .getPropertyValue('--animation-enabled')
    .trim() === '1';
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!elements.length) return;

  if (!animationsEnabled || prefersReduced) {
    elements.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  revealVisibleElements();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.05, rootMargin: '0px 0px 5% 0px' }
  );

  elements.forEach((el) => {
    if (!el.classList.contains('is-visible')) observer.observe(el);
  });

  window.setTimeout(() => {
    elements.forEach((el) => el.classList.add('is-visible'));
  }, 2000);
}

document.addEventListener('DOMContentLoaded', initScrollReveal);
window.addEventListener('pageshow', () => {
  revealVisibleElements();
  document.querySelectorAll('[data-reveal]').forEach((el) => {
    if (!el.classList.contains('is-visible')) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
    }
  });
});
